export const BannerSliderExtra = [
    {
      imgSrc: '/assets/images/components/banners/xoc-dia-pc.webp',
      imgSrcMb: '/assets/images/components/banners/xoc-dia-mb.webp',
      provider: 'hitclub',
      loginRequired: true,
      gameId: 'vgcg_9',
      newTab: true,
      promotionPrevent: true,
      textSearch: 'Xóc Đĩa',
      gameType: 'gamebai_url'
    }
]
